<template lang="pug">
v-menu(open-on-hover, offset-y, :open-delay="1", max-height="640")
  template(v-slot:activator="{ on }")
    v-btn.menu-title(text, v-on="on") 
      v-icon.primary--text(left, small) fa fa-user-alt
      .text-capitalize.primary--text.d-md-block.d-none(v-if="$store.getters['bizes/biz']()") {{ $store.getters['bizes/biz']().name }}
      v-icon.primary--text.d-md-block.d-none(right, small) keyboard_arrow_down
  v-list#user-menu-list.pa-0
    v-subheader {{ $t('Settings.__SiteLanguage') }}
    v-list-item
      span.font-weight-bold(v-if="language == 'tw'") 中文(繁體)
      span(v-else)
        a.text-decoration-underline(@click="changeLanguage('tw')") 中文(繁體)
      span.mx-2 |
      span.font-weight-bold(v-if="language == 'en'") English
      span(v-else)
        a.text-decoration-underline(@click="changeLanguage('en')") English
    v-divider
    v-subheader {{ $t('Menu.__ChangeBiz') }}
    v-list-item.biz-item(
      v-for="biz in $store.state.bizes.mybizes",
      :key="biz.bizId",
      @click="changeBiz(biz)",
      :class="$store.getters['bizes/bid']() == biz.id ? 'actived' : ''"
    )
      v-list-item-title
        .biz {{ biz.name }}
    v-list-item.mybizes-link(:to="'/' + $i18n.locale + '/mybizes'")
      v-list-item-title 
        a {{ $t('Menu.__AllBiz') }}
    v-divider
    v-subheader {{ $t('Menu.__SignedInAs') }} {{ $store.getters['account/email']() }}
    v-list-item(:to="'/' + $i18n.locale + '/settings'")
      v-list-item-title {{ $t('Menu.__Settings') }}
    v-divider
    v-list-item
      v-list-item-title
        a(href="https://www.2sumup.com/blank-1", target="_blank") {{ $t('Auth.__TermsOfService') }}
    v-divider
    v-list-item
      v-list-item-title
        a(href="https://www.2sumup.com/blank-2", target="_blank") {{ $t('Auth.__PrivacyPolicy') }}
    v-divider
    v-list-item(@click="logout")
      v-list-item-title {{ $t('Menu.__SignOut') }}
    v-divider
</template>
<script>
export default {
  data() {
    return {
      mybizes: [],
      lastPage: "",
      language: "tw"
    }
  },
  methods: {
    changeLanguage(key) {
      // this.$store.dispatch("account/updateLanguage", key)
      // this.$i18n.locale = key
      location.href = "/" + key + location.pathname.substring(3)
    },
    changeBiz(biz) {
      this.$store.dispatch("bizes/updateBizInfo", biz)
      this.$store
        .dispatch("account/updateUsedBiz", biz.id)
        .then(function (response) {
          this.$forceUpdate()
          // this.$router.push({ name: "Dashboard" })

          location.href = "/" + this.$i18n.locale + "/dashboard"
        }.bind(this))
        .catch(function (error) { }.bind(this))
    },
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(
          function (response) {
            this.$store.dispatch("account/logout")
            this.$store.dispatch("bizes/logout")
            this.$router.push("/" + this.$i18n.locale + "/login")
          }.bind(this)
        )
        .catch(function (error) { }.bind(this))
    }
  },
  mounted() {
    this.language = this.$route.params.lang
  }
}
</script>

<style lang="scss" scoped>
#user-menu-list {
  .biz-item.actived {
    background-color: #fae3d8;
  }
}
</style>
